import React from "react";

export const LoadingSpinner: React.FC = () => (
  <div className="flex justify-center items-center py-12">
    <div className="w-12 h-12 rounded-full border-b-2 animate-spin border-primary"></div>
  </div>
);
